import React, { useEffect, useState } from "react";
import { listOutbox, flushOutbox, removeFromOutbox } from "@/lib/outbox";
import { X, Trash, ArrowsClockwise, CloudArrowUp } from "@phosphor-icons/react";

const KIND_LABEL = { docket: "Hire Docket", signin: "Sign In / Out", site_diary: "Site Diary" };

function itemLabel(it) {
  if (it.kind === "docket") return `${it.body?.asset_no || "Asset"} — ${it.body?.date || ""}`;
  if (it.kind === "signin") return it.body?.visitor_name ? `Visitor: ${it.body.visitor_name}` : "Worker sign in/out";
  if (it.kind === "site_diary") return `Diary for ${(it.url.split("date=")[1] || "").slice(0, 10)}`;
  return it.kind;
}

export default function PendingUploads({ open, onClose }) {
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState(false);

  const refresh = () => listOutbox().then(setItems).catch(() => {});
  useEffect(() => { if (open) refresh(); }, [open]);

  if (!open) return null;
  const retry = async () => { setBusy(true); await flushOutbox().catch(() => {}); await refresh(); setBusy(false); };
  const discard = async (id) => { await removeFromOutbox(id).catch(() => {}); refresh(); };

  return (
    <div className="fixed inset-0 z-[60] bg-black/60 flex items-end sm:items-center sm:justify-center" data-testid="pending-uploads">
      <div className="bg-white w-full sm:max-w-md max-h-[80vh] flex flex-col">
        <div className="flex items-center justify-between px-4 py-3 bg-equipr-black text-white">
          <h3 className="text-sm font-bold flex items-center gap-2"><CloudArrowUp size={16} weight="bold" className="text-equipr-yellow" /> Pending uploads ({items.length})</h3>
          <button onClick={onClose} data-testid="pending-close" className="text-gray-300 hover:text-white"><X size={18} /></button>
        </div>
        <div className="flex-1 overflow-auto">
          {items.length === 0 ? (
            <p className="p-6 text-center text-sm text-gray-400" data-testid="pending-empty">All caught up — nothing waiting to send.</p>
          ) : items.map((it) => (
            <div key={it.id} className="flex items-center gap-3 px-4 py-3 border-b border-gray-100" data-testid={`pending-item-${it.id}`}>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-semibold text-equipr-black truncate">{KIND_LABEL[it.kind] || it.kind}</p>
                <p className="text-xs text-gray-500 truncate">{itemLabel(it)} · saved {new Date(it.queued_at).toLocaleString("en-AU", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" })}</p>
              </div>
              <button onClick={() => discard(it.id)} data-testid={`pending-discard-${it.id}`}
                title="Discard this entry" className="text-gray-400 hover:text-red-600"><Trash size={16} /></button>
            </div>
          ))}
        </div>
        {items.length > 0 && (
          <div className="p-3 border-t border-gray-200">
            <button onClick={retry} disabled={busy || !navigator.onLine} data-testid="pending-retry"
              className="w-full h-10 bg-equipr-yellow text-equipr-black font-bold rounded-none disabled:opacity-50 inline-flex items-center justify-center gap-2">
              <ArrowsClockwise size={15} weight="bold" /> {busy ? "Sending…" : navigator.onLine ? "Send now" : "Offline — will send automatically"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
